import { createMuiTheme } from '@material-ui/core/styles';

const regularFont = '"NeutrifStudio-Regular", sans-serif';
const boldFont = '"NeutrifStudio-Bold", sans-serif';

export const troyTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#A3E9E3',
      main: '#1AC7B8',
      dark: '#164743',
      contrastText: '#FFFFFF'
    },
    secondary: {
      light: '#B39FCD',
      main: '#5C18B1',
      dark: '#410E81',
      contrastText: '#FFFFFF'
    },
    warning: {
      main: '#FFBC32',
      light: '#FFBC32',
      dark: '#EB6767',
      darkFill: 'rgba(235, 103, 103, 0.1)'
    },
    text: {
      primary: '#313131',
      secondary: '#666666',
      disabled: '#CCCCCC',
      hint: '#999999'
    },
    background: {
      default: '#FFFFFF',
      dark: 'rgba(0, 0, 0, 0.82)'
    },
    action: {
      hover: '#5C18B1',
      disabled: '#E6E6E6',

    },
    grey: {
      50: 'rgba(0, 0, 0, 0.82)',
      100: '#ECECEC',
      200: '#EDEDED',
      300: '#F7F7F7',
      400: '#C6C6C6',
      500: '#B2B2B2'
    }
  },
  typography: {
    fontFamily: regularFont,
    h1: {
      fontFamily: boldFont,
      fontWeight: 400,
      fontSize: '3rem', // 48px
      lineHeight: 1.20833333333, // 58px
      letterSpacing: 'normal'
    },
    h2: {
      fontFamily: boldFont,
      fontWeight: 400,
      fontSize: '2.25rem', // 36px
      lineHeight: 1.33333333333, // 48px
      letterSpacing: 'normal'
    },
    h3: {
      fontFamily: boldFont,
      fontWeight: 400,
      fontSize: '1.5rem', // 24px
      lineHeight: 1.33333333333, // 32px
      letterSpacing: 'normal'
    },
    h4: {
      fontFamily: boldFont,
      fontWeight: 400,
      fontSize: '1.125rem', // 18px
      lineHeight: 1.33333333333, // 24px
      letterSpacing: 'normal'
    },
    subtitle1: {
      fontFamily: regularFont,
      fontWeight: 400,
      fontSize: '0.625rem', // 10px
      lineHeight: 1.6, // 16px
      letterSpacing: 'normal'
    },
    subtitle2: {
      fontFamily: regularFont,
      fontWeight: 400,
      fontSize: '0.75rem', // 12px
      lineHeight: 1.33333333333, // 16px
      letterSpacing: 'normal'
    },
    subtitle2Bold: {
      fontFamily: boldFont,
      fontWeight: 400,
      fontSize: '0.75rem', // 12px
      lineHeight: 1.33333333333, // 16px
      letterSpacing: 'normal'
    },
    subtitle3: {
      fontFamily: regularFont,
      fontWeight: 400,
      fontSize: '0.75rem', // 12px
      lineHeight: 1.5, // 18px
      letterSpacing: '0.6px'
    },
    body1: {
      fontFamily: regularFont,
      fontWeight: 400,
      fontSize: '1rem', // 16px
      lineHeight: 1.5, // 24px
      letterSpacing: 'normal'
    },
    body1Bold: {
      fontFamily: boldFont,
      fontWeight: 400,
      fontSize: '1rem', // 16px
      lineHeight: 1.5, // 24px
      letterSpacing: 'normal'
    },
    body2: {
      fontFamily: regularFont,
      fontWeight: 400,
      fontSize: '0.875rem', // 14px
      lineHeight: 1.14285714286, // 16px
      letterSpacing: 'normal'
    },
    body2Bold: {
      fontFamily: boldFont,
      fontWeight: 400,
      fontSize: '0.875rem', // 14px
      lineHeight: 1.14285714286, // 16px
      letterSpacing: 'normal'
    },
    body3: {
      fontFamily: regularFont,
      fontWeight: 400,
      fontSize: '0.875rem', // 14px
      lineHeight: 1.714285, // 24px
      letterSpacing: 'normal'
    },
  },
  customShadows: {
    menu: '0px 0px 12px rgba(98, 57, 130, 0.6)',
    module: '0px 0px 8px rgba(43, 21, 60, 0.2)',
    login: '0px 0px 20px rgba(23, 77, 72, 0.7)',
    active: '0px 2px 12px rgba(0, 0, 0, 0.2)'
  },
  transitions: {
    custom: {
      fast: 'all ease-in-out 100ms',
      medium: 'all cubic-bezier(0.65, 0, 0.35, 1) 600ms',
      header: 'top 50ms linear'
    }
  }
});
